import { ApiMethod, constructFetchFn } from "@utils/api";
import { API } from "@utils/constants";

export const alipay_qr = () =>
  constructFetchFn({
    method: ApiMethod.GET,
    url: API.ALIPAY_QR_REQUEST,
  });

export const alipay_qr_status = () =>
  constructFetchFn({
    method: ApiMethod.GET,
    url: API.ALIPAY_QR_STATUS,
  });

export const alipay_payment_url = (redirectUrl) =>
  constructFetchFn({
    method: ApiMethod.POST,
    url: API.ALIPAY_WEB_REQUEST,
    body: {
      redirectUrl,
    },
  });

export const alipay_success = (alipayResult) =>
  constructFetchFn({
    method: ApiMethod.POST,
    url: API.ALIPAY_SUCCESS,
    body: {
      alipayResult,
    },
  });

export const fps_info = () =>
  constructFetchFn({
    method: ApiMethod.GET,
    url: API.FPS_QR_REQUEST,
  });

export const custom_html = () =>
  constructFetchFn({
    method: ApiMethod.GET,
    url: API.CUSTOM_HTML,
  });
